import { useEffect, useState } from 'react'

/**
 * A blob: URL holding `content`, revoked when the content changes or the
 * component unmounts. Undefined until the first effect runs, and while there is
 * no content.
 *
 * For links that hand the user a generated file. A data: URL cannot carry
 * arbitrary text: the URL parser starts a fragment at '#', decodes '%XX'
 * sequences, and may drop line breaks, so a CSV cell holding any of them lost
 * or changed the rest of the file.
 */
export const useObjectUrl = (
  content: string | null | undefined,
  type: string
): string | undefined => {
  'use memo'
  const [url, setUrl] = useState<string>()

  useEffect(() => {
    if (content === null || content === undefined) {
      setUrl(undefined)
      return
    }

    const objectUrl = URL.createObjectURL(new Blob([content], { type }))
    setUrl(objectUrl)

    return () => URL.revokeObjectURL(objectUrl)
  }, [content, type])

  return url
}
